import { House, Trees, KeyRound, BookOpen } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";

const ICONS = [House, Trees, KeyRound, BookOpen];

export const FeatureStrip = () => {
  const { t } = useLang();
  return (
    <div className="features" data-testid="feature-strip">
      <div className="wrap features__inner">
        <ul className="features__list">
          {t.features.map((feature, i) => {
            const Icon = ICONS[i];
            return (
              <li key={i} className="features__item" data-testid={`feature-item-${i + 1}`}>
                <Icon className="features__icon" size={27} strokeWidth={1.2} aria-hidden="true" />
                <span className="features__title">{feature.title}</span>
                <span className="features__text">{feature.text}</span>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};
